import { isValidCEP, isValidCPF, isValidCNPJ, isValidEmail, isValidMobilePhone, isValidPhone } from '@brazilian-utils/brazilian-utils';

const INVALID_PHONES = [
    "00000000",
    "000000000",
    "100000000",
    "200000000",
    "300000000",
    "400000000",
    "500000000",
    "600000000",
    "700000000",
    "800000000",
    "900000000",

    "11111111",
    "011111111",
    "111111111",
    "211111111",
    "311111111",
    "411111111",
    "511111111",
    "611111111",
    "711111111",
    "811111111",
    "911111111",

    "22222222",
    "022222222",
    "122222222",
    "222222222",
    "322222222",
    "422222222",
    "522222222",
    "622222222",
    "722222222",
    "822222222",
    "922222222",

    "33333333",
    "033333333",
    "133333333",
    "233333333",
    "333333333",
    "433333333",
    "533333333",
    "633333333",
    "733333333",
    "833333333",
    "933333333",

    "44444444",
    "044444444",
    "144444444",
    "244444444",
    "344444444",
    "444444444",
    "544444444",
    "644444444",
    "744444444",
    "844444444",
    "944444444",

    "55555555",
    "055555555",
    "155555555",
    "255555555",
    "355555555",
    "455555555",
    "555555555",
    "655555555",
    "755555555",
    "855555555",
    "955555555",

    "66666666",
    "066666666",
    "166666666",
    "266666666",
    "366666666",
    "466666666",
    "566666666",
    "666666666",
    "766666666",
    "866666666",
    "966666666",

    "77777777",
    "077777777",
    "177777777",
    "277777777",
    "377777777",
    "477777777",
    "577777777",
    "677777777",
    "777777777",
    "877777777",
    "977777777",

    "88888888",
    "088888888",
    "188888888",
    "288888888",
    "388888888",
    "488888888",
    "588888888",
    "688888888",
    "788888888",
    "888888888",
    "988888888",

    "99999999",
    "099999999",
    "199999999",
    "299999999",
    "399999999",
    "499999999",
    "599999999",
    "699999999",
    "799999999",
    "899999999",
    "999999999",
]
class ValidateUtil {

    static isValidCEP(cep: string): boolean {
        const _cep = cep.replace(/\D/g, "")
        return isValidCEP(_cep);
    }

    static isValidCPF(cpf: string): boolean {
        const _cpf = cpf.replace(/\D/g, "")
        return isValidCPF(_cpf);
    }

    static isValidCNPJ(cnpj: string): boolean {
        const _cnpj = cnpj.replace(/\D/g, "")
        return isValidCNPJ(_cnpj);
    }

    static isValidEmailFromLib(email: string): boolean {
        return isValidEmail(email);
    }

    static isValidPhone(phone: string): boolean {
        const _phone = phone.replace(/\D/g, "")
        
        const _withoutDDD = _phone.substring(2);
        if (INVALID_PHONES.includes(_withoutDDD)) {
            return false;
        }

        return _phone.length >= 11 ? isValidMobilePhone(_phone) : isValidPhone(_phone);
    }
    static isValidEmail(email: string): boolean {
        return !!String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    }

}

export { ValidateUtil }